import api from "../../../../api";
import React from "react";
import utils from "../../../../utils";
import values from "../../../../values";
import Context from "../../../../context";
import convertNumberToPrice from "../../../../utils/convertNumberToPrice";

import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";
import {
  CustomView,
  Pagination,
  CustomIcon,
  CustomModal,
  TableHeader,
  TableLoading,
  TableNullData,
  UserInformation,
} from "../../../../components";

import "./index.sass";
import CustomDropDownSearch from "../../../../components/CustomDropDownMultiSearch";
import { MONTH, SETTELMENT_FILTER } from "../../../../values/dropdownItems";

const ShowAllService: React.FC = (): React.ReactElement => {
  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { showModal, setShowModal, selectedDriver } = React.useContext(
    Context.DriverScreen
  );

  const [pageLimit, setPageLimit] = React.useState({
    page: 1,
    limit: values.constants.PANEL_TABLE_DEFAULT_LIMIT,
  });
  const [selectedYear, setSelectedYear] = React.useState(SETTELMENT_FILTER[0]);
  const [selectedMonth, setSelectedMonth] = React.useState();

  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = React.useState<boolean>(false);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const allService = useQuery([selectedDriver?._id, pageLimit?.page], () =>
    api.post.common.findService({
      ...pageLimit,
      filters: { driver: selectedDriver },
    })
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function handleOpenOrCloseModal(): void {
    setIsModalOpen(!isModalOpen);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="show-all-service-modal-container">
      <CustomModal
        onClose={() => setShowModal!("NONE")}
        open={showModal === "DRIVER_SETTELMENT"}
        minWidth={"55rem"}
        maxWidth={"60rem"}
      >
        <CustomView.Container className="approve-form-content">
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <UserInformation
                name={selectedDriver?.firstName}
                avatar={selectedDriver?.avatar}
                isBlock={
                  !selectedDriver?.driverInformation?.approved?.isApproved
                }
                lastName={selectedDriver?.lastName}
                phoneNumber={selectedDriver?.phoneNumber}
              />
            </CustomView.Column>
            <CustomView.Column className="add-new-service">
              <CustomIcon
                icon={"fa-solid fa-plus"}
                onClick={handleOpenOrCloseModal}
              />
            </CustomView.Column>
          </CustomView.Row>
          <CustomView.Row className="user-information-container">
            <CustomView.Column>
              <CustomDropDownSearch
                label="سال"
                items={SETTELMENT_FILTER}
                baseSearch={[]}
                itemName="name"
                onSelectItem={() => {}}
                placeHolder={""}
                defaultItem={selectedYear}
                setSearchedValue={function (event: any): void {}}
                searchedValue={undefined}
              />
            </CustomView.Column>
            <CustomView.Column className="">
              <CustomDropDownSearch
                label="ماه"
                items={MONTH}
                baseSearch={[]}
                itemName="name"
                defaultItem={selectedMonth}
                onSelectItem={(event) => {setSelectedMonth(event)}}
                placeHolder={"انتخاب ماه"}
                setSearchedValue={function (event: any): void {}}
                searchedValue={undefined}
              />
            </CustomView.Column>
          </CustomView.Row>
          <div className="table-content-wrapper">
            <table>
              <TableHeader
                headers={values.tableHeaders.ALL_SERVICE_FOR_DRIVER}
              />
              {allService.status === "loading" ? (
                <TableLoading />
              ) : (
                <>
                  {(allService?.data?.result?.docs?.length <= 0 ||
                    !allService?.data?.result?.docs) && (
                    <TableNullData text={t("driver_has_not_active_service")} />
                  )}

                  <tbody id="driver-table-body-container">
                    {allService?.data?.result?.docs?.map(
                      (service: any, index: number) => {
                        return (
                          <tr key={`driver-${index}`}>
                            <td className="pointer">
                              <UserInformation
                                avatar={service?.student?.avatar}
                                name={service?.student?.firstName}
                                lastName={service?.student?.lastName}
                                phoneNumber={service?.student?.phoneNumber}
                                isBlock={service?.student?.approved?.isApprove}
                              />
                            </td>
                            <td className="pointer">
                              <UserInformation
                                name={service?.parent?.firstName}
                                lastName={service?.parent?.lastName}
                                phoneNumber={service?.parent?.phoneNumber}
                                isBlock={service?.parent?.approved?.isApprove}
                                hideAvatar
                              />
                            </td>
                            <td className="pointer">
                              <UserInformation
                                avatar={service?.school?.avatar}
                                name={service?.school?.name}
                                phoneNumber={service?.school?.telephone}
                                isBlock={service?.school?.approved}
                                hideAvatar
                              />
                            </td>
                            <td className="pointer">
                              {service?.price && (
                                <div>
                                  {convertNumberToPrice(service?.price)}{" "}
                                  {t("toman")}
                                </div>
                              )}
                            </td>
                            <td>
                              {service?.expire && service?.cycle
                                ? service?.cycle -
                                  (utils.remainDays(service?.expire) %
                                    service?.cycle)
                                : "-"}
                            </td>
                          </tr>
                        );
                      }
                    )}
                  </tbody>
                </>
              )}
            </table>
          </div>
          {allService?.status === "success" &&
            allService?.data?.result?.totalDocs >
              values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
              <div className="pagination">
                <Pagination
                  page={pageLimit?.page}
                  totalPages={allService?.data?.result?.totalPages}
                  onPaginate={(page: number) =>
                    setPageLimit!({ ...pageLimit, page })
                  }
                />
              </div>
            )}
        </CustomView.Container>
      </CustomModal>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default ShowAllService;
